import { render, staticRenderFns, recyclableRender, components } from "./article-item.vue?vue&type=template&id=f7ab0478&scoped=true&"
var renderjs
import script from "./article-item.vue?vue&type=script&lang=js&"
export * from "./article-item.vue?vue&type=script&lang=js&"
import style0 from "./article-item.vue?vue&type=style&index=0&id=f7ab0478&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ab0478",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/article-item/article-item.vue"
export default component.exports